import { Component } from "react"
import { RouteComponentProps } from "react-router-dom"
import { ClientModel, getClientById, IClientData } from "../../api/clients"

import { Client as Client0001 } from "./0x0001/client"
import { Client as Client0002 } from "./0x0002/client"
import { Client as Client0003 } from "./0x0003/client"
import { Client as Client0004 } from "./0x0004/client"
import { Client as Client0005 } from "./0x0005/client"
import { Client as Client0006 } from "./0x0006/client"

type Params = {
    modelId: keyof typeof ClientModel
    clientId: string
}

type State = {
    loading: boolean
    client?: IClientData
}

export class ClientLoader extends Component<RouteComponentProps<Params>> {
    state: State = {
        loading: true,
    }

    componentDidMount = async () => {
        const { clientId } = this.props.match.params
        try {
            const client = (await getClientById(clientId)).data
            this.setState({ client, loading: false })
        } catch (err) {
            console.error('Failed to load client', err)
        }
    }

    render() {
        const { client, loading } = this.state
        if (loading) return <div>Loading...</div>
        if (!client) return <div>Client not found</div>

        switch (client.model) {
            case ClientModel.Standard:
                return <Client0001 client={client} {...this.props} />
            case ClientModel.LTI525S:
                return <Client0002 client={client} {...this.props} />
            case ClientModel.SYRUP_TOWER:
                return <Client0003 client={client} {...this.props} />
            case ClientModel.FILTER_FILLER:
                return <Client0004 client={client} {...this.props} />
            case ClientModel.LTSP101:
            case ClientModel.LTSP70:
            case ClientModel.LTSP175:
                return <Client0005 client={client} {...this.props} />
            case ClientModel.LTCB220:
            case ClientModel.LTCB226:
                return <Client0006 client={client} {...this.props} />

            default: {
                return <div>Unknown model</div>
            }
        }
    }
}
